import React from "react";
import {useEffect} from 'react';
import {Navigate} from "react-router";
import {AppPath} from "../../Router/AppRouter.jsx";
import {useAuth} from "../../context/AuthContext.jsx";

export const Logout = () => {
    const { logout } = useAuth();

    useEffect(() => {
        logout();
    }, []);

    return <Navigate to={AppPath.login} replace />;
};